Vue.component("Background", {
  props: ["background", "zoomBackground"],
  template: `
    <div class="background" :style="{transform: zoomBackground ? 'scale(1.25)' : 'scale(1)'}">

        
        <video v-if="hasVideo()"
            class="background"
            muted
            autoplay
            loop
            playsinline
            webkit-playsinline
            type="video/mp4"
            :src="videoDirectory + background.video"
            @click="backgroundClicked"
            @dblclick="fullscreen"
            @contextmenu.prevent=""
            
        ></video>

        <div class="poster background" v-if="!videoPlaying"></div>

        <div v-if="background.components" class="background-child-component-container">
            <component v-for="c in background.components" :is="c.component" :config="c.props" :style="c.props.style" :class="c.props.cssClass"></component>
        </div>



    </div>

        
    `,
  data() {
    return {
      //default img and video directory for backgrounds for less clutter in manifest.
      videoPlaying: false,
      currentPoster: "",
      imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
      videoDirectory: config.BACKGROUND_VIDEO_DIRECTORY || ''
    };
  },

  mounted() {

    this.$nextTick().then(()=> {
      this.eventListeners = {};
      this.videoPlaying = false;
      console.log("Background MOUNTED", this.background.img);

      // The first time we load the application
      // this page will be shown behind the loader, and
      // when it attempts to request its assets they are not guaranteed to
      // be ready.
      // So we listen to the IMAGE_CACHE_READY event the first time around
      // so we can create our poster image
      window.app.radio.$on("IMAGE_CACHE_READY", () => {
        console.log("IMAGE_CACHE_READY", this.videoPlaying, this.background.img);
        this.createPoster();
      });

      // Then subsequential changes of the scene we can just
      if ("ImageCache" in window.app) {
        window.app.ImageCache.done().then(() => {
          this.createPoster();
        });
      }



      console.log("THis page has a video: ", this.hasVideo(), this.background)
      if (this.hasVideo()) {
        var video = this.$el.querySelector("video");
        if (video) {
          
          this.eventListeners["playing"] = () => {
            this.videoPlaying = true;
          };
          video.addEventListener("playing", this.eventListeners["playing"]);


          setTimeout(()=> {

            console.log("testing video state", video.paused)
            if(video.paused) {
                video.play();
                this.videoPlaying = true;

            }else {
              this.videoPlaying = true;
            }
        }, 1000);
        }
      }
    })
  },

  destroyed() {
    if (this.hasVideo()) {
      var video = this.$el.querySelector("video");
      if (video) {
        Object.keys(this.eventListeners).forEach((event) => {
          video.removeEventListener(event, this.eventListeners[event]);
        });
      }
    }
  },

  methods: {
    hasVideo() {
      return (
        this.background.hasOwnProperty("video") &&
        this.background.video !== "" &&
        this.background.video !== false
      );
    },
    fullscreen() {
      this.$emit("fullscreen");
    },
    backgroundClicked() {
      this.$emit("closeAllContent");
    },
    createPoster() {
      // SHOW IMAGE...
      // if the background.img is correctly formed (the component will get its data sat after it have been created)
      // and the video is not playing
      if (/(\.jpg|\.png)/.test(this.imgDirectory + this.background.img) && !this.videoPlaying) {
        console.log("creating poster");
        this.currentPoster = this.imgDirectory + this.background.img;
        var img = app.ImageCache.getAsset(this.imgDirectory + this.background.img).content;
        Array.from(this.$el.querySelector(".poster").children).forEach((o) =>
          o.remove()
        );
        this.$el.querySelector(".poster").appendChild(img);
      }
    },
  },
});
